import React, { useState } from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

// Custom input que aceita apenas variáveis por drag and drop
export const CustomInputVariavel = ({ value, onChange, variaveis, placeholder }) => {
    const [dragOverType, setDragOverType] = useState(null); // null | 'variavel' | 'node'
    const listId = 'variavel-list';
    const isVar = value && variaveis.some(v => v.nome === value);

    // Handlers internos de drag and drop (igual ao CustomSelect)
    const handleDragOver = (e) => {
        e.preventDefault();
        const isVarType = !!e.dataTransfer.types.find(t => t === 'application/variavel');
        setDragOverType(isVarType ? 'variavel' : 'node');
    };
    const handleDragLeave = () => setDragOverType(null);
    const handleDrop = (e) => {
        e.preventDefault();
        const data = e.dataTransfer.getData('application/variavel');
        if (!data) {
            setDragOverType(null);
            return;
        }
        const v = JSON.parse(data);
        onChange(v.nome);
        setDragOverType(null);
    };
    const handleChange = (e) => {
        onChange(e.target.value);
    };
    const handleRemoveVar = () => {
        onChange('');
    };
    return (
        <div className="custom-input-variavel-wrapper" style={{ position: 'relative' }}>
            <datalist id={listId}>
                {variaveis.map((v, idx) => (
                    <option key={idx} value={v.nome} />
                ))}
            </datalist>
            {isVar ? (
                <div className={`custom-var-chip ${dragOverType === 'variavel' ? 'drag-valid' : ''}`} style={{
                    display: 'flex', alignItems: 'center',
                    border: dragOverType === 'variavel' ? '2px solid #28a745' : '1px solid #28a745',
                    background: '#eaffea',
                    borderRadius: '6px',
                    padding: '6px 12px',
                    minHeight: 38,
                    position: 'relative',
                    marginTop: 4,
                    marginBottom: 4
                }}>
                    <span style={{ fontWeight: 600, color: '#28a745', marginRight: 8 }}>{value}</span>
                    <button onClick={handleRemoveVar} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#dc3545', fontSize: 18, marginLeft: 4 }} title="Remover variável">
                        <CancelIcon fontSize="inherit" />
                    </button>
                </div>
            ) : (
                <input
                    className="custom-var-input"
                    type="text"
                    list={listId}
                    value={value}
                    onChange={handleChange}
                    placeholder={placeholder}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    style={{ marginTop: '4px' }}
                />
            )}
            {dragOverType === 'variavel' && !isVar && (
                <CheckCircleIcon style={{ position: 'absolute', top: 7, right: 2, color: 'green', fontSize: 22, zIndex: 2 }} />
            )}
            {dragOverType === 'node' && !isVar && (
                <CancelIcon style={{ position: 'absolute', top: 7, right: 2, color: 'red', fontSize: 22, zIndex: 2 }} />
            )}
        </div>
    );
};